import {
    featuredMainUrl, featuredAllUrl, firestoreApi, blogMainUrl
} from '../lib/utils';
import FireStoreParser from 'firestore-parser';
import fetch from 'isomorphic-unfetch';
import { firestore } from '../lib/db';
import { Timestamp, collection, query, where, getDoc, orderBy, limit, startAfter, getDocs, doc, setDoc } from "firebase/firestore/lite";
import { FETCH_BLOG_LISTS_ACTION } from './types';

const urlPOST = "https://firestore.googleapis.com/v1/projects/books-af362/databases/(default)/documents:runQuery";

const blogListsMap = {};
export const fetchBlogLists = (genreId) => async (dispatch, getState) => {
    // if (!userInterests) {
    //     return;
    // }
    // const blogLists = getState().blogLists;
    // if (blogLists && blogLists.length > 0) {
    console.dir(genreId);
    if (blogListsMap[genreId]) {
        return;
    }
    console.dir(genreId);
    // const relevantFeaturedLists = ['All'];
    // Object.keys(userInterests).forEach(el => relevantFeaturedLists.push(el));
    // console.dir(relevantFeaturedLists);
    const finalResults = [];
    getDocs(query(collection(firestore, "blog"), where("genreIds", "array-contains-any", [genreId]),
        limit(20)))
        .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
                if (doc.exists()) {
                    finalResults.push(doc.data());
                }
            });
            console.dir(finalResults);
            blogListsMap[genreId] = finalResults;
            dispatch({
                type: FETCH_BLOG_LISTS_ACTION,
                payload: finalResults
            });
        })
        .catch((err) => {
            console.error(err);
        })
}

export const fetchAllBlogArticles = async () => {
    const Query = {        //body of the http request
        "structuredQuery": {
            "from": {
                "collectionId": 'blog',
                "allDescendants": false
            }, "where": {
                "fieldFilter": {
                    "field": { "fieldPath": "active" },
                    "op": "EQUAL",
                    "value": { "booleanValue": true }
                }
            }
        }
    }
    //   "orderBy": {
    //     "field": {
    //       "fieldPath" : "uploaded"
    //     },
    //     "direction" : "DESCENDING"
    //   },
    //   "limit": 1
    const optPOST = {                //http header
        'method': 'post',
        'contentType': 'application/json',
        'muteHttpExceptions': true,
        'body': JSON.stringify(Query)
    };
    //   var response = UrlFetchApp.fetch(urlPOST, optPOST);
    const res = await fetch(urlPOST, optPOST);

    const json = await res.json();
    // console.dir(json);
    const parsedFirestoreJSON = FireStoreParser(json);
    const articles = [];
    for (const doc of parsedFirestoreJSON) {
        const finalJson = doc?.document?.fields || {};
        articles.push(finalJson);
    }
    // console.dir(articles);
    return articles;
}

export const fetchTrendingBlogArticles = async () => {
    const Query = {        //body of the http request
        "structuredQuery": {
            "from": {
                "collectionId": 'blog',
                "allDescendants": false
            }, "where": {
                "fieldFilter": {
                    "field": { "fieldPath": "active" },
                    "op": "EQUAL",
                    "value": { "booleanValue": true }
                }
            },
            "orderBy": {
                "field": {
                    "fieldPath": "score"
                },
                "direction": "DESCENDING"
            },
            "limit": 4
        },
    }
    const optPOST = {                //http header
        'method': 'post',
        'contentType': 'application/json',
        'muteHttpExceptions': true,
        'body': JSON.stringify(Query)
    };
    try {
        //   var response = UrlFetchApp.fetch(urlPOST, optPOST);
        // console.dir(categoryId);
        // console.log('fetchTrendingBlogArticles');
        const res = await fetch(urlPOST, optPOST);
        // console.log('fetchTrendingBlogArticles 2');
        // console.dir(res);
        const json = await res.json();
        // console.dir('res : ' + json);
        // console.log('fetchTrendingBlogArticles 3');
        // console.dir(json);
        const parsedFirestoreJSON = FireStoreParser(json);
        const articles = [];
        for (const doc of parsedFirestoreJSON) {
            const finalJson = doc?.document?.fields || {};
            articles.push(finalJson);
        }
        // console.dir(articles);
        return articles;
    } catch (err) {
        console.error(err);
        return [];
    }
}

export const fetchBlogArticle = async (slug) => {
    const Query = {        //body of the http request
        "structuredQuery": {
            "from": {
                "collectionId": 'blog',
                "allDescendants": false
            }, "where": {
                "compositeFilter": {
                    "filters": [
                        {
                            "fieldFilter": {
                                "field": { "fieldPath": "active" },
                                "op": "EQUAL",
                                "value": { "booleanValue": true }
                            }
                        },
                        {
                            "fieldFilter": {
                                "field": { "fieldPath": "slug" },
                                "op": "EQUAL",
                                "value": { "stringValue": slug }
                            }
                        },
                    ], op: 'AND'
                }
            },
            "limit": 1
        }
    }
    const optPOST = {                //http header
        'method': 'post',
        'contentType': 'application/json',
        'muteHttpExceptions': true,
        'body': JSON.stringify(Query)
    };
    // const url = firestoreApi + `topPodcasts/${genreId}/${fetchIndex}/podcasts`;
    try {
        const res = await fetch(urlPOST, optPOST);
        // console.dir('fetchBlogArticle');
        const json = await res.json();
        // console.dir(json);
        if (json.length > 0) {
            const docName = json[0].document.name;
            const featuredFirestoreIdStrings = docName.split('/blog/');
            const featuredFirestoreId = featuredFirestoreIdStrings.length >= 1 ? featuredFirestoreIdStrings[1] : '';
            // const parsedFirestoreJSON = FireStoreParser(json[0].document);
            // const finalJson = parsedFirestoreJSON?.fields || {};
            // console.dir(finalJson);

            const resFinal = await fetch(blogMainUrl(featuredFirestoreId));
            // console.dir(resFinal);
            const resFinalJson = await resFinal.json();
            const parsedFirestoreJSON2 = FireStoreParser(resFinalJson);
            const finalJson2 = parsedFirestoreJSON2?.fields || {};
            // console.dir(finalJson2);
            return finalJson2;
        } else {
            return {};
        }
    } catch (err) {
        console.error(err);
        return;
    }
}

export async function fetchSpecificBlogList(featuredFirestoreId) {
    try {
        const resFinal = await fetch(blogMainUrl(featuredFirestoreId));
        // console.dir(resFinal);
        const resFinalJson = await resFinal.json();
        const parsedFirestoreJSON2 = FireStoreParser(resFinalJson);
        const finalJson2 = parsedFirestoreJSON2?.fields || {};
        // console.dir(finalJson2);
        return finalJson2;
    } catch (err) {
        //   print('fetchSpecificFeaturedList err : ' + err.toString());
        return {};
    }
}